import React from 'react';
import { FormattedMessage } from 'react-intl';

const mc = (
    <FormattedMessage
        id="dc.bulkRequestSuccessModal.messageCenter"
        defaultMessage="Message Center"
    />
);
const mcLink = <a href="/my/conversations/">{mc}</a>;

export default mcLink;
